export const userActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    SET_CURRENT_ROUTE: 'SET_CURRENT_ROUTE',
    SET_AWS_CREDENTIALS: 'SET_AWS_CREDENTIALS',
    SET_DOWNLOAD_NOTIFS: 'SET_DOWNLOAD_NOTIFS',
    SET_GLOBAL_SEARCH_DATA: 'SET_GLOBAL_SEARCH_DATA',
    SET_EXACT_MATCH_GLOBAL_SEARCH_DATA: 'SET_EXACT_MATCH_GLOBAL_SEARCH_DATA',
};
